import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { broadcastNavigation } from '../slice/uiSlice.jsx';

const EnhancedTypingIndicator = ({ 
  who = "Someone", 
  taskId = null,
  discussionId = null,
  userId = null,
  threadId = null,
  type = 'chat' // 'chat', 'task', or 'thread'
}) =>  {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeTab = useSelector(state => state.ui.activeTab);

  const handleClick = () => {
    if (type === 'task' && taskId) {
      // Navigate to task discussion
      navigate(`/maintask?taskId=${taskId}&discussion=${discussionId}`);
      
      // Broadcast navigation to other tabs
      dispatch(broadcastNavigation({
        type: 'TO_TASK',
        params: { taskId, discussionId },
        clickedFrom: 'typing-indicator'
      }));
      
    } else if (type === 'thread' && threadId) {
      // Navigate to thread discussion
      navigate(`/chat/thread/${threadId}`);
      
      // Broadcast navigation to other tabs
      dispatch(broadcastNavigation({
        type: 'TO_THREAD',
        params: { threadId },
        clickedFrom: 'typing-indicator'
      }));
      
    } else if (type === 'chat' && userId) {
      // Navigate to chat
      navigate(`/chatapp?userId=${userId}`);
      
      // Broadcast navigation to other tabs
      dispatch(broadcastNavigation({
        type: 'TO_CHAT',
        params: { userId },
        clickedFrom: 'typing-indicator'
      }));
    }
  };

  const getTabInfo = () => {
    if (activeTab && activeTab !== getCurrentTabId()) {
      return ` (in Tab ${activeTab.slice(-3)})`;
    }
    return '';
  };

  const getCurrentTabId = () => {
    return `tab-${Date.now()}-${Math.random()}`;
  };

  return (
    <div 
      className="enhanced-typing-indicator clickable" 
      onClick={handleClick}
      title={`Click to navigate to ${type === 'task' ? 'task discussion' : type === 'thread' ? 'thread discussion' : 'chat'}`}
    >
      <span className="typing-content">
        <strong>{who}</strong> is typing
        {type === 'task' && taskId && (
          <span className="task-info"> in Task #{taskId}</span>
        )}
        {type === 'thread' && threadId && (
          <span className="thread-info"> in Thread Discussion</span>
        )}
        <span className="tab-info">{getTabInfo()}</span>
        <span className="click-hint"> - click to open</span>
      </span>
    </div>
  );
};

export default EnhancedTypingIndicator;
